import React from 'react';
import { useTheme } from 'styled-components';

import ArrowButton, { ArrowLinkButtonProps } from 'Elements/Button/Arrow';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';

import AvatarTabNavigation, { AvatarTabsProps } from 'Modules/TabNavigation/Avatar';

import { Inner, WaveWrapper, Wave } from './SolentStory.styled';

export interface Props {
    heading: string;
    text: string;
    cta?: ArrowLinkButtonProps;
    tabNavigation: AvatarTabsProps;
}

const SolentStory: React.FC<Props> = ({ heading, text, cta, tabNavigation }) => {
    const { colors } = useTheme();

    return (
        <Section
            id="graduate-stories"
            background
            backgroundColor={colors.secondary.tints[0].hex}
            paddingTop={1}
        >
            <WaveWrapper>
                <Wave />
            </WaveWrapper>
            <Grid rowGap="1rem">
                <Col m={8} l={4} align="center">
                    <Inner>
                        <h2>{heading}</h2>
                        <p>{text}</p>
                        {cta && <ArrowButton {...cta} variant="petrolBlueSolid" />}
                    </Inner>
                </Col>
                <Col m={10} l={8}>
                    <AvatarTabNavigation {...tabNavigation} />
                </Col>
            </Grid>
        </Section>
    );
};

export default SolentStory;
